import { Logger } from 'data/common';

function debug(eventName, params) {
    Logger.debug(`FHEPool : <---------- Event Received ${eventName}`, params);
}

function bindSettingsEvents(FHEProductInstance) {
    FHEProductInstance.socketOn('fheProductStatus', function(args) {
        const { product_identifier: productIdentifier, product_type: productType, status } = args;
        debug('fheProductStatus', args);

        if (status === 'undefined' || productIdentifier === 'undefined' || productType === 'undefined')
            return Logger.error(`Arguments manquants sur l'envent socket fheProductStatus : "${args}"`);
        if (!FHEProductInstance.getState().environments.fhepool.data.hasOwnProperty(productType))
            return Logger.error(`Product type "${productType}" non configuré`);
        if (!FHEProductInstance.getState().environments.fhepool.data[productType].hasIn(['list', productIdentifier]))
            return Logger.debug(`Le produit "${productIdentifier}" (${productType}) n'est pas présent dans le store`);

        FHEProductInstance.dispatch({
            type: `FHEPOOL__FHEPRODUCT_UPDATE_${productType}_STATUS`,
            productIdentifier,
            status
        });
    });

    FHEProductInstance.socketOn('fheProductRemove', function(args) {
        const { product_identifier: productIdentifier, product_type: productType } = args;
        debug('fheProductRemove', args);

        if (productIdentifier === 'undefined' || productType === 'undefined')
            return Logger.error(`Arguments manquants sur l'envent socket fheProductStatus : "${args}"`);
        if (!FHEProductInstance.getState().environments.fhepool.data.hasOwnProperty(productType))
            return Logger.error(`Product type "${productType}" non configuré`);
        if (!FHEProductInstance.getState().environments.fhepool.data[productType].hasIn(['list', productIdentifier]))
            return Logger.debug(`Le produit "${productIdentifier}" (${productType}) n'est pas présent dans le store`);

        FHEProductInstance.dispatch({
            type: `FHEPOOL__FHEPRODUCT_REMOVE_${productType}`,
            productIdentifier
        });
    });

    FHEProductInstance.socketOn('fheProductDissociateUser', function(args) {
        const { product_identifier: productIdentifier, product_type: productType, user_id: userId } = args;
        debug('fheProductDissociateUser', args);

        if (userId === 'undefined' || productIdentifier === 'undefined' || productType === 'undefined')
            return Logger.error(`fheProductDissociateUser : Arguments manquants sur l'envent socket : "${args}"`);
        if (!FHEProductInstance.getState().environments.fhepool.data.hasOwnProperty(productType))
            return Logger.error(`fheProductDissociateUser : Product type "${productType}" non configuré`);
        if (!FHEProductInstance.getState().environments.fhepool.data[productType].hasIn(['list', productIdentifier]))
            return Logger.debug(`fheProductDissociateUser : Le produit "${productIdentifier}" (${productType}) n'est pas présent dans le store`);

        FHEProductInstance.dispatch({
            type: `FHEPOOL__FHEPRODUCT_DISSOCIATE_USER_${productType}`,
            productIdentifier,
            userId
        });
    });

    FHEProductInstance.socketOn('fheProductDissociateUserAndSwitchMaster', function(args) {
        const { product_identifier: productIdentifier, product_type: productType, user_id: userId, master_id: masterId } = args;
        debug('fheProductDissociateUserAndSwitchMaster', args);

        if (userId === 'undefined' || productIdentifier === 'undefined' || productType === 'undefined')
            return Logger.error(`fheProductDissociateUserAndSwitchMaster : Arguments manquants sur l'envent socket : "${args}"`);
        if (!FHEProductInstance.getState().environments.fhepool.data.hasOwnProperty(productType))
            return Logger.error(`fheProductDissociateUserAndSwitchMaster : Product type "${productType}" non configuré`);
        if (!FHEProductInstance.getState().environments.fhepool.data[productType].hasIn(['list', productIdentifier]))
            return Logger.debug(
                `fheProductDissociateUserAndSwitchMaster : Le produit "${productIdentifier}" (${productType}) n'est pas présent dans le store`
            );

        FHEProductInstance.dispatch({
            type: `FHEPOOL__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_${productType}`,
            productIdentifier,
            userId,
            masterId
        });
    });

    FHEProductInstance.socketOn('fheProductMasterSwitch', function(args) {
        const { product_identifier: productIdentifier, product_type: productType, master_id: masterId } = args;
        debug('fheProductMasterSwitch', args);

        if (masterId === 'undefined' || productIdentifier === 'undefined' || productType === 'undefined')
            return Logger.error(`Arguments manquants sur l'envent socket fheProductStatus : "${args}"`);
        if (!FHEProductInstance.getState().environments.fhepool.data.hasOwnProperty(productType))
            return Logger.error(`Product type "${productType}" non configuré`);
        if (!FHEProductInstance.getState().environments.fhepool.data[productType].hasIn(['list', productIdentifier]))
            return Logger.debug(`Le produit "${productIdentifier}" (${productType}) n'est pas présent dans le store`);

        FHEProductInstance.dispatch({
            type: `FHEPOOL__FHEPRODUCT_MASTER_SWITCH_${productType}`,
            productIdentifier,
            masterId
        });
    });
}

export default function initBinds(FHEProductInstance) {
    bindSettingsEvents(FHEProductInstance);
}



// WEBPACK FOOTER //
// ./environments/fhepool/eventsSocket/FHEProduct/binds.js